<template>
  <div class="w-100">
    <ColorInput
      :label="t('common.background')"
      :color="store?.formStyle?.background"
      @update:color="handleFormBackground"
    />
  </div>
  <div class="w-100 grid grid-cols-2 gap-4">
    <div>
      <div class="flex items-center">
        <div class="hl-text-xs-medium">{{ t("common.primaryColor") }}</div>
        <UITooltip trigger="hover" placement="top" :style="{ maxWidth: '300px' }">
          <template #trigger>
            <InfoCircleIcon class="ml-1 h-4 w-4 text-gray-400"></InfoCircleIcon>
          </template>
          {{ t("common.primaryColorTooltip") }}
        </UITooltip>
      </div>
      <ColorInput
        :color="store?.fieldStyle?.primaryColor"
        :clearable="true"
        @update:color="handlePrimaryColor"
      />
    </div>
    <div>
      <div class="flex items-center">
        <div class="hl-text-xs-medium">{{ t("common.inputTextColor") }}</div>
        <UITooltip trigger="hover" placement="top" :style="{ maxWidth: '300px' }">
          <template #trigger>
            <InfoCircleIcon class="ml-1 h-4 w-4 text-gray-400"></InfoCircleIcon>
          </template>
          {{ t("common.inputTextColorTooltip") }}
        </UITooltip>
      </div>
      <ColorInput :color="store?.fieldStyle?.fontColor" @update:color="handleFieldFontColor" />
    </div>
  </div>
  <div v-if="product === PRODUCT_TYPE.FORM" class="w-100">
    <UICheckbox
      id="mapPrimaryColorToButtonColorCheckbox"
      v-model="store.fieldStyle.mapPrimaryColorToButtonColor"
      :label="t('common.mapPrimaryColorToButtonColor')"
      :disabled="isMapPrimaryColorDisabled"
      :checked="store?.fieldStyle?.mapPrimaryColorToButtonColor"
      @update:checked="handleMapPrimaryColorToButtonColor"
    />
  </div>
  <div class="w-100 grid grid-cols-2 gap-4">
    <ColorInput
      :label="t('common.style.inputBackgroundColor')"
      :color="store?.fieldStyle?.bgColor"
      @update:color="handleFieldBackground"
    />
    <ColorInput
      :label="t('common.style.inputBorder')"
      :color="store?.fieldStyle?.border?.color"
      @update:color="handleFieldBorderColor"
    />
  </div>
  <ImageUpload :header="t('common.backgroundImage')" field="bgImage" />
  <ImageUpload :header="t('common.headerImage')" field="headerImageSrc" />
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { PRODUCT_TYPE } from "@/util/constants";
import { InfoCircleIcon } from "@gohighlevel/ghl-icons/24/outline";
import { UICheckbox, UITooltip } from "@gohighlevel/ghl-ui";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import ColorInput from "../Elements/ColorInput.vue";
import ImageUpload from "../Elements/ImageUpload.vue";

const { t } = useI18n();
const store = useAppStore();

// Computed property to check if checkbox should be disabled
const isMapPrimaryColorDisabled = computed(() => {
  return !store.fieldStyle?.primaryColor || store.fieldStyle.primaryColor === "";
});

defineProps({
  product: {
    type: String,
    default: "form",
  },
});

const handleFormBackground = (val: string) => {
  store.formStyle.background = val;
  store.anyUnsavedChanges = true;
};

const handleFieldFontColor = (val: string) => {
  store.fieldStyle.fontColor = val;
  store.anyUnsavedChanges = true;
};

const handleFieldBackground = (val: string) => {
  store.fieldStyle.bgColor = val;
  store.anyUnsavedChanges = true;
};

const handleFieldBorderColor = (val: string) => {
  store.fieldStyle.border.color = val;
  store.anyUnsavedChanges = true;
};

const handlePrimaryColor = (val: string) => {
  store.fieldStyle.primaryColor = val;
  store.anyUnsavedChanges = true;
};

const handleMapPrimaryColorToButtonColor = (val: boolean) => {
  store.fieldStyle.mapPrimaryColorToButtonColor = val;
  store.anyUnsavedChanges = true;
};
</script>
